import request from "@/utils/request";

// 查付款账户
export function queryFmAccount(params) {
    return request({
        url: '/fm/fmAccount/query',
        method: 'get',
        params
    })
}